import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
//
import LogoLoader from './LogoLoader';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  zIndex: 99999,
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // Glassmorphic translucent blue background
  backgroundColor: alpha('#070c1e', 0.65), 
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
}));

// ----------------------------------------------------------------------

LoadingScreen.propTypes = {
  isDashboard: PropTypes.bool,
};

export default function LoadingScreen({ isDashboard, ...other }) {
  // Render the loading screen unconditionally when requested (ignores isDashboard check to ensure it always renders globally)
  return (
    <RootStyle {...other}>
      <LogoLoader size={120} />
    </RootStyle>
  );
}
